






























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { UserGroupUser } from "@/services/users/types";
import { getUsersForUserGroup } from "@/services/users/userGroupService";
import { userGroupUsersFields } from "@/components/users/fields/userGroupUsersFields";
import SelectUsersModal from "@/components/users/modals/SelectUsersModal.vue";
import UserGroupUserDeleteModal from "@/components/users/modals/UserGroupUserDeleteModal.vue";
@Component({
    components: { UserGroupUserDeleteModal, SelectUsersModal }
})
export default class UserGroupUsers extends Vue {
        @Prop() groupId!: string;
        @Prop() collapseState!: boolean;
        // local state
        localGroupId = "";
        users = [] as UserGroupUser[];
        searchQuery = "";
        fields = userGroupUsersFields;
        localCollapseState = true;

        // watchers
        @Watch("groupId")
        onPropertyChanged() {
            this.localGroupId = this.groupId;
            this.localCollapseState = this.collapseState;
            this.fetchData();
        }

        // lifecycle hooks

        // computed
        get filteredData() {
            return this.users && this.users
                .filter(x => this.searchQuery.length === 0 ||
                    (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                        x.email.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                    x.roles.some(role => role.toLowerCase().includes(this.searchQuery.toLowerCase())));
        }

        // methods
        fetchData() {
            getUsersForUserGroup(this.localGroupId).then(response => {
                this.users = response;
                this.$emit("initUsers", this.users.map(x => x.userId));
            });
        }

        openUsersPrompt() {
            (this.$refs.selectUsers as any).open(true);
        }

        setState(state:boolean) {
            if (this.localCollapseState === state) return;

            this.localCollapseState = state;
            this.$emit("componentStateChanged", { name: "UserGroupUsers", state: state });
        }

        onUserSelected(userGroups: UserGroupUser[]) {
            const usersToBeAdded = userGroups
                .filter(x => !this.users.map(x => x.userId).includes(x.userId));
            if (usersToBeAdded.length > 0) {
                this.users = this.users.concat(usersToBeAdded);
            }
        }

        removeUser(user: UserGroupUser) {
            (this.$refs.deleteUser as any).open(user.userId, user.name);
        }

        onDeleted(id: string) {
            const item = this.users.find(x => x.userId === id);
            if (!item) {
                return;
            }
            this.users = this.users.filter(x => x.userId !== id);
        }

        // events
        emitData() {
            this.$emit("usersUpdated", this.users.map(x => x.userId));
        }
}
